export * from './src/ngx-uploader/module/ngx-uploader.module';
export * from './src/ngx-uploader/classes/ngx-uploader.class';
export { UploadStatus } from './src/ngx-uploader/classes/interfaces';
export * from './src/ngx-uploader/directives/ng-file-select.directive';
export * from './src/ngx-uploader/directives/ng-file-drop.directive';



//////////////////
// WEBPACK FOOTER
// C:/Users/re5pect/Desktop/siterepoProject/Admin panel/SiteRepoAdminPanel/~/ngx-uploader/lib/index.js
// module id = ../../../../ngx-uploader/lib/index.js
// module chunks = 3